<template>
    <v-app-bar
        light
        clipped
        elevation="1"
        :color="theming.topBarColor || 'white'"
        height="55px"
        fixed
        style="z-index: 100000;"
        class="top-bar"
    >
        <v-app-bar-nav-icon :color="theming.sideBarText || 'black'" class="included" @click.stop="setDrawer">
            <v-icon v-if="drawer" :color="theming.sideBarText|| 'black'" large>mdi-menu-open</v-icon>
            <v-icon v-else :color="theming.sideBarText|| 'black'" large>mdi-menu</v-icon>
        </v-app-bar-nav-icon>
        <v-img v-if="!isWhitelabel" max-width="120px" contain :src="require(`@/assets/companies/${this.companyName}.png`)" />
        <fibryo-logo v-else class="fibryo-logo" :color="theming.sideBarText" />
        <v-spacer />
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn fab small color="white" v-bind="attrs" v-on="on">
                    <v-icon color="black">mdi-cog-outline</v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item class="py-0 my-0" link @click="goToProfile">
                    <v-icon class="pr-2" color="#FFC000">mdi-account</v-icon> <v-list-item-title class="custom-text"> Προφίλ </v-list-item-title>
                </v-list-item>
                <v-list-item class="py-0 my-0" link @click="goToTheming">
                    <v-icon class="pr-2" color="#78bdab">mdi-palette</v-icon> <v-list-item-title class="custom-text"> Χρώμα </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isAdminOrCompanyCoordinator" class="py-0 my-0" link @click="goToImports">
                    <v-icon class="pr-2" color="#0047AB">mdi-arrow-expand-up</v-icon> <v-list-item-title class="custom-text"> Import </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isAdminOrCompanyCoordinator && (config.hasStorage || config.hasPagonisFileExportInfo || hasBackOfficeSap)" class="py-0 my-0" link @click="goToExports">
                    <v-icon class="pr-2" color="#0047AB">mdi-arrow-collapse-down</v-icon> <v-list-item-title class="custom-text"> Export </v-list-item-title>
                </v-list-item>
                <v-list-item class="py-0 my-0" link @click="logout">
                    <v-icon class="pr-2" color="red">mdi-logout</v-icon> <v-list-item-title class="custom-text"> Έξοδος </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
    import userService from '@/services/user'
    import moment from 'moment'
    import FibryoLogo from '@/components/FibryoLogoSVG'
    const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME

    export default {
        components: { FibryoLogo },
        data() {
            return {
                active: false,
                icon: 'mdi-view-grid-outline',
                tokenExpiration: '',
                interval: null,
                remainingMinutes: null
            }
        },
        computed: {
            companyName() {
                return COMPANY_NAME
            },
            isWhitelabel() {
                return this.companyName === 'fibryo'
            },
            refreshTokenExpiration() {
                return this.$store.getters.getRefreshTokenExpiration
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            hasBackOfficeSap() {
                return this.config?.backOffice?.steps?.some(step => step.value === 'sapUpload')
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            drawer: {
                get() {
                    return this.$store.getters.getDrawer
                },
                set(value) {
                    return value
                }
            }
        },
        watch: {
            // tokenExpiration() {
            //     this.remainingMinutes = moment(this.refreshTokenExpiration).subtract(30, 'minutes').diff(moment(), 'minutes')
            // }
        },
        methods: {
            // myAssignmentsClick() {
            //     if (this.isMyAssignmentsEnabled) {
            //         this.$store.dispatch('setMyAssignmentsEnabled', false)
            //     } else {
            //         this.$store.dispatch('setMyAssignmentsEnabled', true)
            //     }
            // },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            setDrawer() {
                this.$store.dispatch('setDrawer', !this.drawer)
            },
            logout() {
                this.$store.dispatch('logout').then(() => this.$router.push(`/login`))
            },
            calculateTokenExpiration(newEpoch) {
                if (newEpoch) {
                    const expiration = moment(newEpoch)
                    const diff = expiration.diff(moment().utc().subtract(30, 'minutes'))
                    this.tokenExpiration = moment.utc(diff).format('mm:ss')
                }
            },
            refreshToken() {
                userService.refreshToken({
                    tokenValue: this.$store.getters.getRefreshToken
                }).then(resp => {
                    this.$store.dispatch('setRefreshToken', resp.data.refreshToken)
                    this.$store.dispatch('setRefreshTokenExpiration', resp.data.refreshTokenExpiration)
                    this.$store.dispatch('setToken', resp.data.token)
                })
            },
            goToProfile() {
                this.$router.push('/my-profile')
            },
            goToImports() {
                this.$router.push('/imports')
            },
            goToExports() {
                this.$router.push('/exports')
            },
            goToTheming() {
                this.$router.push('/colors')
            }
            // setExpireTokenInterval() {
            //     if (this.interval) {
            //         clearInterval(this.interval)
            //     }
            //     this.calculateTokenExpiration(this.refreshTokenExpiration)
            //     this.interval = setInterval(() => {
            //         this.calculateTokenExpiration(this.refreshTokenExpiration)
            //     }, 1000)
            // }
        }
    }
</script>

<style scoped>
.fibryo-logo {
    height: 100%;
    width: 100px;
}
.top-bar {
    background: linear-gradient(to top, var(--sidebar-color), color-mix(in srgb, var(--sidebar-color) 85%, black));
}
.v-button {
    text-transform: none !important;
}
.custom-text{
    font-size:small;
}

.session-timer{
    font-size: medium;
    font-weight: 700;
    width: 100px;
    height: 30px;
    border: 2px solid black;
}

.session-timer-danger{
    border-color: red !important;
    color: red !important;
}

</style>
